// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"a60aca84","494":"880eeef5"}[chunkId] + ".chunk.js";
};